import { Editor } from 'grapesjs';
import { QLFEDITOR_BUTTON_CLASSNAME } from '@loyalty/editor-components';
import { facButton } from '@qualifio/ui-commons';
import { EditorComponentDefinition } from './types';
import { LinkWidgetTraits } from './link/LinkWidgetTraits';
import { translateAttributes } from '../../services/copy-paste/copy-paste-utils';

export const buttonComponentDefinition: EditorComponentDefinition = {
  id: 'button',
  icon: facButton,
  category: 'Content',
  getLabel: ({ t }) => t('editor.component.button'),
  component: ButtonGrapesComponent,
  copyPasteHelper: (element, context) => translateAttributes(element, context.destinationLocales),
  traits: {
    form: LinkWidgetTraits,
  },
};

export function ButtonGrapesComponent(editor: Editor) {
  editor.DomComponents.addType(buttonComponentDefinition.id, {
    extend: 'custom-link',
    model: {
      defaults: {
        attributes: { className: QLFEDITOR_BUTTON_CLASSNAME },
      },
    },
  });
}
